export default {
	properties: {
		emailAlerts: { type: 'string' },
	},
	required: ['emailAlerts'],
	additionalProperties: false,
}
